import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class BrokerInvitation extends DomainObject {
  @observable email;
  @observable status;
}

export default BrokerInvitation;
